<template>
    <product-list :cards="cards"/>
</template>

<script>
import ProductList from './ProductList.vue'
import components from '../component.js'
export default {
    name: 'zoezi-resourcebooking-service-list',

    zoezi: {
        title: 'Resource booking services',
        icon: 'mdi-format-list-text',
        addon: 'ResourceBooking'
    },

    props: {
        categoryId: {
            title: 'Category',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                multiple: false,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getResourceBookingCategories(),
                selectFirst: true
            }
        },
        serviceIds: {
            title: 'Services',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                filter: (x, props) => ( props.categoryId ? x.category_id == props.categoryId : true) && x.show,
                getItems: () => window.$zoeziapi.get('/api/resourcebooking/service/get/all'),
                selectFirst: true
            },
            default: () => []
        }
    },

    components: {
        ProductList
    },

    data: () => ({
        category: null,
        services: []
    }),

    computed: {
        cards() {
            return this.services.map(service => {
                let title = service.name;
                let image = '';
                let shortDescription = service.description;
                let config = components.makeEmptyConfig({component: 'zoezi-product-card', props: {title, image, shortDescription}})

                return config;
            });
        }
    },

    watch: {
        categoryId: {
            immediate: true,
            handler() {
                this.$booking.getResourceBookingCategories().then(cats => {
                    this.category = cats.find(c => this.categoryId == c.id);
                })
            }
        },
        serviceIds: {
            immediate: true,
            handler() {
                this.$api.get('/api/public/resourcebooking/service/get', {category: this.categoryId}).then(services => {
                    this.services = this.serviceIds ? this.serviceIds.map(id => services.find(s => s.id == id)).filter(x => x) : []
                })
            }
        }
    }
}
</script>
